export interface PhotosPageData {
  groupName: string;
  photos: Array<string>;
  linkRoute: any | null;
  nonLinkText: string | null;
  source: GroupingType;
  sortValueAsc: string;
  sortValueDesc: string;
  additionalInfo: string;
  locationShortPhotoSummariesList?: Array<LocationShortPhotoSummary> | null;
  adventureShortPhotoSummariesList?: Array<AdventureShortPhotoSummary> | null;
  uploadCampaignShortPhotoSummariesList?: Array<UploadCampaignShortPhotoSummary> | null;
  creatorShortPhotoSummariesList?: Array<CreatorShortPhotoSummary> | null;
  myUploadsGroupId?: string | null;
}

export type GroupingType = "adventure" | "creator" | "location" | "community-upload" | "my-uploads";

export type SubGroupingType = "byLocation" /* | "byHighlights" */ | "byAdventure" | "byUploadCampaign" | "byCreator";

export interface LocationShortPhotoSummary {
  locationId: string;
  locationName: string;
  photos: Array<string>;
}

export interface AdventureShortPhotoSummary {
  adventureId: string;
  adventureName: string;
  photos: Array<string>;
}

export interface UploadCampaignShortPhotoSummary {
  uploadCampaignId: string;
  uploadCampaignName: string;
  photos: Array<string>;
}

export interface CreatorShortPhotoSummary {
  creatorId: string;
  creatorName: string;
  photos: Array<string>;
  additionalInfo?: string;
}

export interface PhotoSubGroup {
  id: string;
  type: SubGroupingType | null;
  title: string | null;
  photos: Array<string>;
  additionalInfo?: string | null;
}

export const additionalInfoStringDividerSymbol = "-----";

// Data from server ===========================================================
export interface AdventurePhotoSummaryFromServer {
  adventureId: string;
  adventureName: string;
  collabPhotos: Array<string>;
  creatorCredit: string;
  creatorDisplayName: string;
  creatorId: string;
  isCollab: boolean;
  locations: Array<any>;
  publishedDate: string;
  titlePhoto: string;
  uniqueName: string;
}

export interface CommunityUploadPhotoSummaryFromServer {
  additionalInfo: string;
  campaignId: string;
  campaignName: string;
  createdDate: string;
  photos: Array<string>;
  uploadersEmail: string;
  uploadersName: string;
}

export interface CustomerGalleryPhotoGroupsFromServer {
  customerId: string;
  deletedDate: string | null;
  groupId: string | null;
  groupName: string | null;
  comment: string | null;
  id: string | null; // "PG-funtown"
  photoIds: Array<string>;
  pkey: string;
  type: "PhotoGalleryCustomer";
  // Audit fields
  createdOn: string;
  createdBy: string;
  updatedOn: string;
  updatedBy: string;
}

export interface PhotosPageDataFromServer {
  adventurePhotoSummaries: Array<AdventurePhotoSummaryFromServer>;
  communityId: string;
  communityTitle: string;
  communityUniqueName: string;
  communityUploadPhotoSummaries: Array<CommunityUploadPhotoSummaryFromServer>;
  customerGalleryPhotoGroups: Array<CustomerGalleryPhotoGroupsFromServer>;
  customerGalleryPhotos: Array<string>;
}
